<template>
  <LayoutCard>
    <div class="chip">
      <CommonChip transparent size="small" :color="color"> {{ label }} </CommonChip>
    </div>
    <slot />
  </LayoutCard>
</template>

<script setup lang="ts">
import CommonChip from '../common/CommonChip.vue'
import LayoutCard from '../layout/LayoutCard.vue'

withDefaults(
  defineProps<{
    label?: string
    color?: ApplicationColors
  }>(),
  {
    label: 'Label',
    color: 'success'
  }
)
</script>

<style scoped>
.chip {
  margin-bottom: 10px;
}
</style>
